import angular from 'angular';
import uiRouter from 'angular-ui-router';
import groupInvoiceComponent from './group-invoice.component';

let groupInvoiceModule = angular.module('Group-Invoice', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newGroupInvoice', {
            url: '/group-invoices/new',
            component: 'groupInvoice',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editGroupInvoice', {
            url: '/group-invoices/:id',
            component: 'groupInvoice',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                groupInvoice: (
                    GroupInvoicesService,
                    $stateParams
                ) =>  GroupInvoicesService.findById($stateParams.id, {
                    include: [
                        'client',
                        {
                            relation: 'quotes',
                            scope: {
                                include: ['holder', 'vehicle']
                            }
                        },
                        {
                            relation: 'receipts',
                            scope: {
                                include: [{
                                    relation: 'receiptGroupInvoices',
                                    scope: {
                                        where: {
                                            groupInvoiceId: $stateParams.id
                                        }
                                    }
                                }]
                            }
                        }
                    ]
                })
            }
        });
})
.component('groupInvoice', groupInvoiceComponent)
.name;

export default groupInvoiceModule;
